var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00638 5.93728C3.34297 7.81852 2.33337 10.2914 2.33337 13C2.33337 18.891 7.109 23.6666 13 23.6666C15.7087 23.6666 18.1815 22.6571 20.0627 20.9936L5.00638 5.93728ZM6.46585 4.56833L21.4317 19.5342C22.8327 17.729 23.6667 15.4619 23.6667 13C23.6667 7.10894 18.8911 2.33331 13 2.33331C10.5381 2.33331 8.27101 3.16737 6.46585 4.56833ZM0.333374 13C0.333374 6.00437 6.00443 0.333313 13 0.333313C19.9956 0.333313 25.6667 6.00437 25.6667 13C25.6667 19.9956 19.9956 25.6666 13 25.6666C6.00443 25.6666 0.333374 19.9956 0.333374 13Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlocked);
export default __webpack_public_path__ + "static/media/icon-blocked.5100ae04ec58a42ea8024cd4b9f13ed8.svg";
export { ForwardRef as ReactComponent };